<div class="container jury">
  <h2 id="juryHeader">Die Jury</h2>
  <div class="jurorGrid">
    <div class="juror" *ngFor="let juror of jurorList; let i = index">
      <div class="image">
        <img [ngSrc]="'./assets/img/jury/' + juror.name + '.jpg'" width="300" height="300" alt="" />
      </div>
      <div class="logo">
        <img [ngSrc]="juror.logo" width="200" height="200" [alt]="juror.logo + ' Logo'" />
      </div>
      <div class="text">
        <div class="head">
          <div class="left">
            <div class="name">{{ juror.name }}</div>
            <div class="position">{{ juror.position }}</div>
          </div>
        </div>
        <div class="description">
          {{ juror.quote }}
          <em *ngIf="juror.qouteSource">- {{ juror.qouteSource }}</em>
        </div>
      </div>
    </div>
  </div>
</div>
